(() => {
  if (window.goomiLiveChatReady) return;
  window.goomiLiveChatReady = true;

  // Theme markup uses the class; the href form lets merchants link to chat from
  // any rich text field without touching code.
  const TRIGGER_SELECTOR = '.live-chat-trigger, a[href="#live-chat-trigger"]';

  /**
   * Opens Gorgias chat from any trigger on the page.
   *
   * window.GorgiasChat is a Proxy that throws on any property other than
   * init/resolve until the widget has loaded, so reading .open() directly
   * fails for anyone who clicks before then. init() returns a promise that
   * resolves once the chat is ready.
   */
  const openChat = (trigger) => {
    // Missing when the app embed is off or a content blocker stopped the script.
    if (typeof window.GorgiasChat === 'undefined') return;

    trigger.setAttribute('aria-busy', 'true');

    window.GorgiasChat.init()
      .then((chat) => {
        const api = chat && typeof chat.open === 'function' ? chat : window.GorgiasChat;
        api.open();
      })
      .catch(() => {})
      .finally(() => trigger.removeAttribute('aria-busy'));
  };

  document.addEventListener('click', (evt) => {
    const trigger = evt.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    evt.preventDefault();
    openChat(trigger);
  });
})();
